import * as R from 'ramda'
import { general } from '../../helpers/api/api'
import { errorToBeAdded } from '../error'
import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from '../../helpers/api/meta'

export const LOAD_GENERAL_STARTED = 'LOAD_GENERAL_STARTED'
export const LOAD_GENERAL_SUCCESS = 'LOAD_GENERAL_SUCCESS'
export const LOAD_GENERAL_FAILURE = 'LOAD_GENERAL_FAILURE'
export const LOAD_GENERAL_ENDED = 'LOAD_GENERAL_ENDED'

export const loadGeneralStarted = () => ({ type: LOAD_GENERAL_STARTED })
export const loadGeneralSuccess = success => ({ type: LOAD_GENERAL_SUCCESS, success })
export const loadGeneralFailure = error => ({ type: LOAD_GENERAL_FAILURE, error })
export const loadGeneralEnded = () => ({ type: LOAD_GENERAL_ENDED })

const saveGeneral = (state, action) => {  
  return R.assoc('agencies', action.success.agencies, state)
}

const messages = {
  loadFailed: 'Could not load general info.',
}

const initialState = {
  loading: false,
  agencies: [],
}

export const loadGeneral = () => (dispatch) => {
  dispatch(loadGeneralStarted())
  return general()
    .then((success) => {
      dispatch(loadGeneralEnded())
      dispatch(loadGeneralSuccess(success))
    })
    .catch((error) => {
      dispatch(loadGeneralEnded())
      dispatch(errorToBeAdded(error, 'general', messages.loadFailed))
      dispatch(loadGeneralFailure(error))
    })
}

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_GENERAL_STARTED: {
      return startLoading(clearError(state));
    }
    case LOAD_GENERAL_ENDED: {
      return stopLoading(state);
    }
    case LOAD_GENERAL_SUCCESS: {
      return saveGeneral(state, action);
    }
    case LOAD_GENERAL_FAILURE: {
      return saveErrorMsg(state, action, messages.loadFailed);
    }
    default:
      return state;
  }
}